import * as Yup from "yup";


 const bankClearanceValidation = Yup.object().shape({
    nationalId: Yup.string().required('کد ملی را وارد کنید.').min(10,'کد ملی 10 رقم می باشد.')

})
export default bankClearanceValidation;